export type AndroidBrowser = 'huawei' | 'heytap' | 'samsung' | 'googleApp' | 'other';

export interface AndroidBrowserInfo {
  userAgent: string;
  isAndroid: boolean;
  browser: AndroidBrowser;
}

export const getUserAgent = (): string => {
  if (typeof navigator === 'undefined') {
    return '';
  }

  return navigator.userAgent ?? '';
};

export const isTikTokWebView = (): boolean => {
  return /BytedanceWebview|musical_ly|TikTok|TTWebView/i.test(getUserAgent());
};

export const getBrowserInfo = (): AndroidBrowser => {
  const userAgent = getUserAgent();

  if (/huaweibrowser\//i.test(userAgent)) {
    return 'huawei';
  }

  if (/heytapbrowser\//i.test(userAgent)) {
    return 'heytap';
  }

  if (/samsungbrowser\//i.test(userAgent)) {
    return 'samsung';
  }

  if (/\bGSA\/\d/i.test(userAgent) || /\bGoogleApp\/\d/i.test(userAgent)) {
    return 'googleApp';
  }

  return 'other';
};
